export default __webpack_public_path__ + "static/media/lightening.3f0cb1bd.svg";